// "use client";
// import { useState, useRef, useEffect, useMemo } from "react";
// import Skeleton from "react-loading-skeleton";
// import { closeIconOverlay } from "../../assets";
// import VideoPlayer from "../video/VideoPlayer";
// import { useVideoContext } from "../video/VideoProvider";
// import ImageLoader from "./ImageLoader";

// const MediaViewer = ({
//   media = [],
//   setShowMediaViewer,
//   imgRes = "800",
//   zoomImgRes = "1500",
// }) => {
//   const { pauseAll } = useVideoContext();

//   const [selectedIndex, setSelectedIndex] = useState(0);
//   const thumbsRef = useRef([]);
//   const mainRef = useRef([]);

//   const [mainsLoaded, setMainsLoaded] = useState(
//     Array(media.length).fill(false)
//   );
//   const getHighRes = (url) =>
//     url
//       ?.replace?.("r200x200", `r${imgRes}x${imgRes}`)
//       ?.replace?.("v200x200", `v${imgRes}x${imgRes}`);
//   const getZoomRes = (url) =>
//     url
//       ?.replace?.("r200x200", `r${zoomImgRes}x${zoomImgRes}`)
//       ?.replace?.("v200x200", `v${zoomImgRes}x${zoomImgRes}`);

//   // Build items with highRes/zoomUrl (only include zoomUrl if distinct)
//   const validMedia = useMemo(
//     () =>
//       (media || [])
//         .filter((item) => item && (item.mediaThumb || item.mediaUrl))
//         .map((item) => {
//           const baseUrl =
//             item?.mediaThumb && typeof item.mediaThumb === "string"
//               ? item.mediaThumb
//               : item.mediaUrl;

//           const highResUrl = getHighRes(baseUrl);
//           const zoomUrl = getZoomRes(baseUrl);

//           return {
//             ...item,
//             highResUrl,
//             // ✅ Only include a distinct zoom URL if it’s different
//             zoomUrl: zoomUrl !== highResUrl ? zoomUrl : undefined,
//           };
//         }),
//     [media]
//   );
//   // ----------------------------------------------------

//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === "Escape") {
//         handleClose();
//       }
//     };

//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, [setShowMediaViewer]);

//   useEffect(() => {
//     if (media.length > 0) {
//       pauseAll();
//     }
//   }, [media.length]);

//   // Scroll mains when their image is loaded
//   useEffect(() => {
//     if (mainsLoaded[selectedIndex] && mainRef.current[selectedIndex]) {
//       mainRef.current[selectedIndex].scrollIntoView({
//         behavior: mainsLoaded[selectedIndex] ? "smooth" : "auto",
//         inline: "center",
//         block: "nearest",
//       });
//     }
//   }, [selectedIndex, mainsLoaded]);

//   const goPrev = () => {
//     setSelectedIndex((prev) => (prev === 0 ? media.length - 1 : prev - 1));
//   };

//   const goNext = () => {
//     setSelectedIndex((prev) => (prev === media.length - 1 ? 0 : prev + 1));
//   };

//   const handleMainLoad = (index) => {
//     setMainsLoaded((prev) => {
//       const copy = [...prev];
//       copy[index] = true;
//       return copy;
//     });
//   };

//   const handleClose = () => {
//     pauseAll();
//     setShowMediaViewer(false);
//   };

//   return (
//     <div className="media-view-overlay" onClick={() => handleClose()}>
//       <button className="overlay-close" onClick={() => handleClose()}>
//         {closeIconOverlay}
//       </button>

//       {media.length > 1 && (
//         <div
//           className="nav-arrow-div left"
//           onClick={(e) => {
//             goPrev();
//             e.stopPropagation();
//           }}
//         >
//           <button className="nav-arrow left">&#10094;</button>
//         </div>
//       )}

//       {media.length > 1 && (
//         <div
//           className="nav-arrow-div right"
//           onClick={(e) => {
//             goNext();
//             e.stopPropagation();
//           }}
//         >
//           <button className="nav-arrow right">&#10095;</button>
//         </div>
//       )}
//       <div
//         className="media-view-container"
//         onClick={(e) => e.stopPropagation()}
//       >
//         {/* Left - Thumbnails */}
//         <section
//           className="vertical-img-scroll"
//           onClick={(e) => e.stopPropagation()}
//         >
//           {validMedia.map((item, index) => (
//             <div
//               key={item._id}
//               ref={(el) => (thumbsRef.current[index] = el)}
//               className={`media-thumb-container ${
//                 index === selectedIndex ? "active" : ""
//               }`}
//               onMouseEnter={() => setSelectedIndex(index)}
//               onClick={() => setSelectedIndex(index)}
//             >
//               <ImageLoader
//                 className="media-thumb"
//                 imgRes="300"
//                 media={item}
//                 skeletonHeight={100}
//                 skeletonWidth={100}
//                 alt={item.name}
//               />
//             </div>
//           ))}
//         </section>

//         {/* Right - Main horizontal scroll */}
//         <section className="horizontal-img-scroll">
//           <div className="media-main-strip">
//             {validMedia.map((item, index) => (
//               <div
//                 key={item._id}
//                 ref={(el) => (mainRef.current[index] = el)}
//                 className={`media-main-item ${
//                   index === selectedIndex ? "active" : ""
//                 }`}
//               >
//                 {item.mediaType === "image" && (
//                   <div
//                     className="media-main-wrapper"
//                     onClick={(e) => e.stopPropagation()}
//                   >
//                     <ImageLoader
//                       media={item}
//                       zoom={true}
//                       zoomPreload={true}
//                       alt={item.name}
//                       skeletonHeight={500}
//                       skeletonWidth={500}
//                     />
//                   </div>
//                 )}

//                 {/* Video */}
//                 {item.mediaType === "video" && (
//                   <div
//                     className="media-main-wrapper"
//                     style={{
//                       width: "100%",
//                       height: "100%",
//                       position: "relative",
//                     }}
//                   >
//                     <VideoPlayer
//                       src={item.mediaUrl}
//                       className="media-main-video"
//                       skeletonHeight={500}
//                       skeletonWidth={500}
//                       autoPlay={true}
//                       continuousPlay={true}
//                     />
//                   </div>
//                 )}

//                 {/* PDF / file */}
//                 {item.mediaType === "file" && (
//                   <div
//                     className="media-main-wrapper"
//                     style={{
//                       width: "100%",
//                       height: "100%",
//                       position: "relative",
//                     }}
//                     onClick={(e) => e.stopPropagation()}
//                   >
//                     {!mainsLoaded[index] && (
//                       <Skeleton width={500} height={500} />
//                     )}

//                     <iframe
//                       src={item.mediaUrl}
//                       className="media-main-pdf"
//                       title={item.mediaName}
//                       onLoad={() => handleMainLoad(index)}
//                       style={{
//                         opacity: mainsLoaded[index] ? 1 : 0,
//                         display: mainsLoaded[index] ? "block" : "none",
//                         transition: "opacity 0.3s ease",
//                       }}
//                     ></iframe>
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default MediaViewer;

"use client";
import { useState, useRef, useEffect, useMemo } from "react";
import { closeIconOverlay } from "../../assets";
import VideoPlayer from "../video/VideoPlayer";
import { useVideoContext } from "../video/VideoProvider";
import ImageLoader from "./ImageLoader";
import PdfLoader from "./PdfLoader";

const MediaViewer = ({
  media = [],
  setShowMediaViewer,
  imgRes = "800",
  zoomImgRes = "1500",
}) => {
  const { pauseAll } = useVideoContext();

  const [selectedIndex, setSelectedIndex] = useState(0);
  const thumbsRef = useRef([]);
  const mainRef = useRef([]);

  const getHighRes = (url) =>
    url
      ?.replace?.("r200x200", `r${imgRes}x${imgRes}`)
      ?.replace?.("v200x200", `v${imgRes}x${imgRes}`);
  const getZoomRes = (url) =>
    url
      ?.replace?.("r200x200", `r${zoomImgRes}x${zoomImgRes}`)
      ?.replace?.("v200x200", `v${zoomImgRes}x${zoomImgRes}`);

  // Build items with highRes/zoomUrl (only include zoomUrl if distinct)
  const validMedia = useMemo(
    () =>
      (media || [])
        .filter((item) => item && (item.mediaThumb || item.mediaUrl))
        .map((item) => {
          const baseUrl =
            item?.mediaThumb && typeof item.mediaThumb === "string"
              ? item.mediaThumb
              : item.mediaUrl;

          const highResUrl = getHighRes(baseUrl);
          const zoomUrl = getZoomRes(baseUrl);

          return {
            ...item,
            highResUrl,
            // ✅ Only include a distinct zoom URL if it’s different
            zoomUrl: zoomUrl !== highResUrl ? zoomUrl : undefined,
          };
        }),
    [media]
  );

  // Close on Escape
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setShowMediaViewer]);

  // pause all videos when viewer opens / media changes
  useEffect(() => {
    if (media.length > 0) {
      pauseAll();
    }
  }, [media.length, pauseAll]);

  // Scroll the selected main item into view immediately when selectedIndex changes
  useEffect(() => {
    const el = mainRef.current[selectedIndex];
    if (el && typeof el.scrollIntoView === "function") {
      el.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  const goPrev = () => {
    setSelectedIndex((prev) => (prev === 0 ? media.length - 1 : prev - 1));
  };

  const goNext = () => {
    setSelectedIndex((prev) => (prev === media.length - 1 ? 0 : prev + 1));
  };

  const handleClose = () => {
    pauseAll();
    setShowMediaViewer(false);
  };

  return (
    <div className="media-view-overlay" onClick={() => handleClose()}>
      <button className="overlay-close" onClick={() => handleClose()}>
        {closeIconOverlay}
      </button>

      {media.length > 1 && (
        <div
          className="nav-arrow-div left"
          onClick={(e) => {
            goPrev();
            e.stopPropagation();
          }}
        >
          <button className="nav-arrow left">&#10094;</button>
        </div>
      )}

      {media.length > 1 && (
        <div
          className="nav-arrow-div right"
          onClick={(e) => {
            goNext();
            e.stopPropagation();
          }}
        >
          <button className="nav-arrow right">&#10095;</button>
        </div>
      )}

      <div
        className="media-view-container"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Left - Thumbnails */}
        <section
          className="vertical-img-scroll"
          onClick={(e) => e.stopPropagation()}
        >
          {validMedia.map((item, index) => (
            <div
              key={item._id || index}
              ref={(el) => (thumbsRef.current[index] = el)}
              className={`media-thumb-container ${
                index === selectedIndex ? "active" : ""
              }`}
              onMouseEnter={() => setSelectedIndex(index)}
              onClick={() => setSelectedIndex(index)}
            >
              <ImageLoader
                className="media-thumb"
                imgRes="300"
                media={item}
                skeletonHeight={100}
                skeletonWidth={100}
                alt={item.name}
              />
            </div>
          ))}
        </section>

        {/* Right - Main horizontal scroll */}
        <section className="horizontal-img-scroll">
          <div className="media-main-strip">
            {validMedia.map((item, index) => (
              <div
                key={item._id || index}
                ref={(el) => (mainRef.current[index] = el)}
                className={`media-main-item ${
                  index === selectedIndex ? "active" : ""
                }`}
              >
                {item.mediaType === "image" && (
                  <div
                    className="media-main-wrapper"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <ImageLoader
                      media={item}
                      zoom={true}
                      zoomPreload={true}
                      alt={item.name}
                      skeletonHeight={500}
                      skeletonWidth={500}
                    />
                  </div>
                )}

                {item.mediaType === "video" && (
                  <div
                    className="media-main-wrapper"
                    style={{
                      width: "100%",
                      height: "100%",
                      position: "relative",
                    }}
                  >
                    <VideoPlayer
                      src={item.mediaUrl}
                      className="media-main-video"
                      skeletonHeight={500}
                      skeletonWidth={500}
                      autoPlay={true}
                      continuousPlay={true}
                    />
                  </div>
                )}

                {item.mediaType === "file" && (
                  <div
                    className="media-main-wrapper"
                    style={{
                      width: "100%",
                      height: "100%",
                      position: "relative",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <PdfLoader
                      media={item}
                      skeletonHeight={500}
                      skeletonWidth={500}
                      pdfStyle={{
                        width: "100%",
                        height: "100%",
                        border: "none",
                        transition: "opacity 0.3s ease",
                      }}
                      className="media-main-pdf"
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default MediaViewer;
